export const CommonLabelTextHelper = {
    getLabelText: {
        filterCurrentPage: 'Filter Current Page'
    }
};
